import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
export const migrateEmployeeData = (axios: IAxiosInstance) => {
  return async (body: any) => {
    const response = await axios.noRetry.post<IApiResponse<any>>(
      `/api/migrate-employee-data`,
      body
    );
    return response.data;
  };
};
